import loggerIcons from 'nordic/logger';

const log = loggerIcons('loadable-icon-wrapper');

const withLog = (WrappedComponent, tags = {}) => {
  const { message, ...restOptions } = tags;

  const WithLog = props => {
    log.error(message, restOptions);
    return <WrappedComponent {...props} />;
  };

  WithLog.displayName = `WithLog(${WrappedComponent?.displayName || WrappedComponent?.name || 'Component'})`;

  return WithLog;
};

export default withLog;
